import React, { Fragment } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
// Components
import SocialMediaMention from "../components/Card/SocialMediaMention";
import DigitalSentiment from "../components/Chart/Sentiment";
import RecentPosts from "../components/Card/RecentPosts";
import DigitalAverageCount from "../components/Card/Average";
import EmptyData from "../components/EmptyData";

// Material Icons
import GoogleIcon from "@mui/icons-material/Google";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import BlurOnOutlinedIcon from "@mui/icons-material/BlurOnOutlined";

export default function GooglePage({ ...props }) {
  const { data } = props;

  const sortSentimentLength = (array, sentiment) => {
    const filteredData = array.filter((x) => x.sentiment === sentiment);
    return filteredData.length;
  };

  return (
    <Fragment>
      {data?.data?.length > 0 ? (
        <Grid container spacing={4} sx={{ pb: 8 }}>
          <Grid item xs={12} md={12}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body1" fontWeight="600" sx={{ mb: 1 }}>
                      Digital Mention
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <SocialMediaMention icon={<GoogleIcon />} data={data} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" fontWeight="600" sx={{ mb: 1 }}>
                  Sentiment Analysis
                </Typography>
                <DigitalSentiment sentiment={data} />
              </Grid>
              <Grid item xs={12} md={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body1" fontWeight="600" sx={{ mb: 1 }}>
                      Sentiment Analysis
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <DigitalAverageCount
                      average={sortSentimentLength(data.data, "Netral")}
                      isAverage={true}
                      title="Total of Netral Sentiment"
                      icon={
                        <BlurOnOutlinedIcon
                          sx={{
                            width: 25,
                            height: 25,
                            color: "rgba(0, 0, 0, 0.6)",
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <DigitalAverageCount
                      average={sortSentimentLength(data.data, "Negatif")}
                      isAverage={true}
                      title="Total of Negatif Sentiment"
                      icon={
                        <ThumbDownOutlinedIcon
                          sx={{
                            width: 25,
                            height: 25,
                            color: "rgba(0, 0, 0, 0.6)",
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <DigitalAverageCount
                      average={sortSentimentLength(data.data, "Positif")}
                      isAverage={true}
                      title="Total of Positive Sentiment"
                      icon={
                        <ThumbUpOutlinedIcon
                          sx={{
                            width: 25,
                            height: 25,
                            color: "rgba(0, 0, 0, 0.6)",
                          }}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography variant="body1" fontWeight="600" sx={{ mb: 3 }}>
                  Recent Post
                </Typography>
                <RecentPosts data={data.data.slice(0, 6)} type={"Google"} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <EmptyData />
      )}
    </Fragment>
  );
}
